export default __webpack_public_path__ + "static/media/step1-assessment-results-26.294db3b3.gif";